import React, { useState } from "react";
import Section from "./Section";
import { X_PADDING } from "../constants";
import Page from "./Page";

const ResearchInnovation = () => {
  return (
    <Page name="Research and Innovation Hub">
      <div className="w-full pt-8 bg-white">
        {/*Careers */}
        <Section
          name="JOURNAL"
          description="Share and explore research, clinical studies, 
          and professional publications that advance evidence-based practice. 
          Members can submit manuscripts for review and contribute to knowledge that strengthens the clinical profession."
        />
      </div>
    </Page>
  );
};
export default ResearchInnovation
